<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Fulfillment Pricing</li>
    </ol>
  </nav>
  <form>
    <div class="row">
      <div class="col">
        <div class="inner-box">
          <div class="row">
            <div class="col-6">
              <div class="form-radio">
                <input type="radio" id="customer" [(ngModel)]="pricingType" (click)="clear()" [ngModelOptions]="{standalone: true}" required
                       value="CUSTOMER" name="type">
                <label for="customer">Customer Pricing</label>
              </div>
            </div>
            <div class="col-6">
              <div class="form-radio">
                <input type="radio" id="orgRepricing" [(ngModel)]="pricingType" (click)="getOrgList();clear()" [ngModelOptions]="{standalone: true}" required
                       value="ORG REPRICING" name="type">
                <label for="orgRepricing">Default Pricing </label>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="row mt-3" [hidden]="pricingType != 'CUSTOMER'">
                <div class="col-md-3">
                  <div class="form-group mb-md-0">
                    <label class="control-label">Customer</label>
                    <ng-select id="accountOwner" [(ngModel)]="accountOwner" (change)="getList()"
                               [ngModelOptions]="{standalone: true}" required
                               [items]="accountOwners"
                               bindLabel="ownerName"
                               bindValue="id"
                               [searchFn]="customSearchAccountOwner"
                               [searchWhileComposing]="true">
                      <ng-template ng-option-tmp let-item="item">
                        {{item?.ownerName}} <br/>
                        <small>{{item?.companyName}}</small>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
              </div>
              <div class="row mt-3" [hidden]="pricingType != 'CUSTOMER'">
                <div class="col">
                  <div class="table-3">
                    <table class="table packing-table-2">
                      <thead class="thead-light">
                      <tr>
                        <th>Service type</th>
                        <th>Price per unit</th>
                      </tr>
                      </thead>
                      <tbody>

                      <tr *ngFor="let sl of servicesList">
                        <td>{{sl.service | replaceStatus}}</td>
                        <td><input type="text" [(ngModel)]="sl.pricing" [ngModelOptions]="{standalone: true}"
                                   onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"  class="form-control width-120"></td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="row mt-3" [hidden]="pricingType != 'ORG REPRICING'">
                <div class="col">
                  <div class="table-3">
                    <table class="table packing-table-2">
                      <thead class="thead-light">
                      <tr>
                        <th>Service type</th>
                        <th>Price per unit</th>
                      </tr>
                      </thead>
                      <tbody>

                      <tr *ngFor="let s of services">
                        <td>{{s.service | replaceStatus}}</td>
                        <td><input type="text" [(ngModel)]="s.pricing" [ngModelOptions]="{standalone: true}"
                                   onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"   class="form-control width-120"></td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </form>
</section>

<div class="form-btn-section">
  <div class="row">
    <div class="col-12 text-right">
      <button type="reset" routerLink="/admin/adminDashboard/" class="btn btn-cancel">Cancel</button>
      <button type="submit" [hidden]="pricingType === 'ORG REPRICING'" (click)="fulfillmentSave()" class="btn btn-orange ml-2">Save</button>
      <button type="submit" [hidden]="pricingType === 'CUSTOMER'" (click)="orgSave()" class="btn btn-orange ml-2">Save</button>
    </div>
  </div>
</div>
